<template>
  <!-- 精选语音解答 -->
  <div class="audiogolawer">
    <subTitle text="精选语音解答" />
    <div class="golawerlist">
      <div
        class="golaweritem"
        v-for="(item, index) in list"
        :key="index"
        @click="tojump(item)"
      >
        <div class="wtbt ellipsis">{{ item.title }}</div>
        <div class="wthd">
          {{ item.content | toEllipsisFilter(110) }}
        </div>
        <div class="wtlabel between">
          <div class="flex_start">
            <div class="FontSize14 flex_start">
              <div class="lawin">
                <img :src="item.avatar" />
                {{ item.true_name }}
              </div>
              <div class="tjaoplay flex_start">
                <img src="~assets/claimdet/audioplay.png" />{{ item.duration }}
              </div>
            </div>
          </div>
          <div class="flex_end">
            <div class="time flex_start FontSize12">
              <img src="~assets/claim/time.png" />{{ item.updated_at }}
            </div>
            <div class="biaoqian flex_start FontSize12">
              <img src="~assets/claimdet/detbaqaicon.png" />{{ item.tag }}
            </div>
            <div class="liulan flex_start FontSize12">
              <img src="~assets/base/kan.png" />{{ item.view_num }}次浏览
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  props: ["list"],
  components: {
    subTitle,
  },
  methods: {
    tojump(item) {
      this.$router.push({
        path: "/laws/audioimdet",
        query: {
          audioinId: item.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.audiogolawer {
  margin-top: 20px;
  width: 100%;
  .golawerlist {
    padding-top: 20px;
    .golaweritem {
      padding: 30px 32px;
      cursor: pointer;
      &:hover {
        .wtbt {
          color: #0465ea;
        }
        box-shadow: 1px 1px 6px 0px rgba(0, 0, 0, 0.08);
      }
      .wtbt {
        font-size: 20px;
        color: #333333;
      }
      .wthd {
        font-size: 14px;
        color: #666666;
        margin: 20px 0;
      }
      .wtlabel {
        color: #999999;
        .lawin {
          margin-right: 15px;
          img {
            width: 31px;
            height: 32px;
            border-radius: 50%;
          }
        }
        .tjaoplay {
          width: 113px;
          height: 29px;
          background: #eeeeee;
          font-size: 13px;
          color: #333333;
          border-radius: 3px;
          padding-left: 10px;
          img {
            width: 16px;
            height: 16px;
            margin-right: 10px;
          }
        }
        .biaoqian,
        .liulan {
          margin-left: 30px;
        }
        img {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>